import { lazyPage, type ModulePlugin } from "@keel/core";

const settings = () => import("./Settings");
const Settings = lazyPage(settings, "Settings");
const ApiKeys = lazyPage(() => import("./ApiKeys"), "ApiKeys");
const Audit = lazyPage(() => import("./Audit"), "Audit");
const Operator = lazyPage(() => import("./Operator"), "Operator");
const Account = lazyPage(() => import("./Account"), "Account");
const companies = () => import("./Companies");
const Companies = lazyPage(companies, "Companies");
const CompanyPage = lazyPage(companies, "CompanyPage");
const files = () => import("./Files");
const PartyFiles = lazyPage(files, "PartyFiles");
const ProductFiles = lazyPage(files, "ProductFiles");
const EmployeeFiles = lazyPage(files, "EmployeeFiles");
const PartyNotes = lazyPage(files, "PartyNotes");
const PartyHistory = lazyPage(files, "PartyHistory");
const ProductNotes = lazyPage(files, "ProductNotes");
const EmployeeNotes = lazyPage(files, "EmployeeNotes");
const Tasks = lazyPage(() => import("./Tasks"), "Tasks");

/** Platform: settings, users & roles, modules, API keys, audit log, operator console. */
const plugin: ModulePlugin = {
  key: "platform",
  records: { Company: "/companies/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Platform",
      items: [
        { to: "/tasks", label: "Tasks", icon: "check" },
        { to: "/api-keys", label: "API keys", icon: "key", perm: "platform.api_keys.manage" },
        { to: "/audit", label: "Audit log", icon: "history", perm: "platform.audit.read" },
        { to: "/companies", label: "Companies", icon: "building", perm: "platform.companies.read" },
        { to: "/settings", label: "Settings", icon: "settings", perm: "platform.companies.read" },
        { to: "/operator", label: "Customers & plans", icon: "grid", operator: true },
      ],
    },
  ],
  routes: [
    { path: "/settings", element: <Settings /> },
    { path: "/companies", element: <Companies /> },
    { path: "/tasks", element: <Tasks /> },
    { path: "/companies/:id", element: <CompanyPage /> },
    { path: "/api-keys", element: <ApiKeys /> },
    { path: "/audit", element: <Audit /> },
    { path: "/operator", element: <Operator /> },
    { path: "/account", element: <Account /> },
  ],
  commands: [
    ["My tasks", "/tasks", "check", ""],
    ["API keys", "/api-keys", "key", "platform.api_keys.manage"],
    ["Audit log", "/audit", "history", "platform.audit.read"],
    ["Users & roles", "/settings?tab=users", "shield", "platform.users.read"],
    ["Roles & permissions", "/settings?tab=roles", "shield", "platform.roles.read"],
    ["Business rules", "/settings?tab=rules", "sliders", "platform.companies.write"],
    ["Companies", "/companies", "building", "platform.companies.read"],
    ["Add a company", "/companies/new", "plus", "platform.companies.write"],
    ["Modules", "/settings?tab=modules", "boxes", "platform.modules.manage"],
    ["API reference", "/api/v1/openapi.json", "code", ""],
    ["My account, password and two-factor sign-in", "/account", "key", ""],
  ],
  // Files on records other modules own. No `perm` here: the component asks the API what this user
  // may see, which is the owning module's permission, not a platform one.
  // Notes too (ERP-72): a customer's page also shows the notes written on its invoices and contracts.
  partyTabs: [{ key: "history", label: "History", component: PartyHistory }],
  partyPanels: [
    { key: "notes", component: PartyNotes },
    { key: "files", component: PartyFiles },
  ],
  productSections: [
    { key: "notes", component: ProductNotes },
    { key: "files", component: ProductFiles },
  ],
  employeeTabs: [
    { key: "notes", label: "Notes", component: EmployeeNotes },
    { key: "files", label: "Documents", component: EmployeeFiles },
  ],
};
export default plugin;
/** Used by the shell's tenant-less start screen, where no module page can render yet. */
export { NewCustomer, TotpSetup } from "./setup";
